var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPebbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.08,
    cy: 28.348,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.988,
    cy: 29.86,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.577,
    cy: 67.28,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.872,
    cy: 46.113,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.87,
    cy: 69.17,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.083,
    cy: 68.792,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.93,
    cy: 32.128,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.494,
    cy: 20.033,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.18,
    cy: 46.113,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.271,
    cy: 48.381,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.47,
    cy: 63.5,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.24,
    cy: 39.688,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.068,
    cy: 26.836,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.98,
    cy: 20.033,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.74,
    cy: 30.616,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 35.152,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.351,
    cy: 48.759,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.83,
    cy: 63.122,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.26,
    cy: 56.696,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.72,
    cy: 59.342,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.199,
    cy: 35.152,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.327,
    cy: 21.167,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.42,
    cy: 19.277,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.19,
    cy: 39.31,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.458,
    cy: 55.185,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.688,
    cy: 72.193,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.682,
    cy: 40.443,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.667,
    cy: 58.208,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.7,
    cy: 25.702,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.01,
    cy: 19.655,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.76,
    cy: 34.774,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.3,
    cy: 46.869,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.31,
    cy: 47.625,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.35,
    cy: 67.658,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.18,
    cy: 61.232,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.58,
    cy: 70.682,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.03,
    cy: 52.917,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.964,
    cy: 37.798,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.423,
    cy: 32.128,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.006,
    cy: 51.405,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.42,
    cy: 32.128,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.107,
    cy: 36.664,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.601,
    cy: 26.836,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.75,
    cy: 56.696,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.658,
    cy: 56.696,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.14,
    cy: 42.711,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.896,
    cy: 71.438,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.82,
    cy: 64.256,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.49,
    cy: 51.783,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.41,
    cy: 39.31,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.56,
    cy: 22.301,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.777,
    cy: 74.083,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.68,
    cy: 75.595,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.274,
    cy: 113.01,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.57,
    cy: 91.848,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.56,
    cy: 114.9,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.78,
    cy: 114.53,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.62,
    cy: 77.863,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.19,
    cy: 65.768,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.88,
    cy: 91.848,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.97,
    cy: 94.116,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.17,
    cy: 109.24,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.93,
    cy: 85.423,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.76,
    cy: 72.571,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.67,
    cy: 65.768,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.44,
    cy: 76.351,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.41,
    cy: 80.887,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.05,
    cy: 94.494,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.53,
    cy: 108.86,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.96,
    cy: 102.43,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.41,
    cy: 105.08,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.896,
    cy: 80.887,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.02,
    cy: 66.902,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.116,
    cy: 65.012,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.887,
    cy: 85.045,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.155,
    cy: 100.92,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.384,
    cy: 117.93,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.38,
    cy: 86.179,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.36,
    cy: 103.94,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.4,
    cy: 71.438,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.71,
    cy: 65.39,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.46,
    cy: 80.509,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206,
    cy: 92.604,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 93.36,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.04,
    cy: 113.39,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.88,
    cy: 106.97,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 194.28,
    cy: 116.42,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.73,
    cy: 98.652,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.66,
    cy: 83.533,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.12,
    cy: 77.863,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.7,
    cy: 97.14,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.11,
    cy: 77.863,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.8,
    cy: 82.399,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.3,
    cy: 72.571,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.446,
    cy: 102.43,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.35,
    cy: 102.43,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.84,
    cy: 88.446,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.59,
    cy: 117.17,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.51,
    cy: 109.99,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.18,
    cy: 97.518,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.11,
    cy: 85.045,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.26,
    cy: 68.036,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.961,
    cy: 77.863,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.869,
    cy: 79.375,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.458,
    cy: 116.79,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.753,
    cy: 95.628,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.75,
    cy: 118.68,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.964,
    cy: 118.31,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.81,
    cy: 81.643,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.375,
    cy: 69.548,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.06,
    cy: 95.628,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.152,
    cy: 97.896,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.351,
    cy: 113.01,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.116,
    cy: 89.202,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.949,
    cy: 76.351,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.86,
    cy: 69.548,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.62,
    cy: 80.131,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.595,
    cy: 84.667,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.232,
    cy: 98.274,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.711,
    cy: 112.64,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.14,
    cy: 106.21,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.6,
    cy: 108.86,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.08,
    cy: 84.667,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.208,
    cy: 70.682,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.301,
    cy: 68.792,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.0714,
    cy: 88.824,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.339,
    cy: 104.7,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.568,
    cy: 121.71,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.562,
    cy: 89.958,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.548,
    cy: 107.72,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.58,
    cy: 75.217,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.89,
    cy: 69.17,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.65,
    cy: 84.289,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.18,
    cy: 96.384,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.19,
    cy: 97.14,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.226,
    cy: 117.17,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.06,
    cy: 110.75,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.46,
    cy: 120.2,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.91,
    cy: 102.43,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.845,
    cy: 87.312,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.304,
    cy: 81.643,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.887,
    cy: 100.92,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.3,
    cy: 81.643,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.988,
    cy: 86.179,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.482,
    cy: 76.351,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.631,
    cy: 106.21,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.539,
    cy: 106.21,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.021,
    cy: 92.226,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.777,
    cy: 120.95,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.7,
    cy: 113.77,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.37,
    cy: 101.3,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.29,
    cy: 88.824,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.44,
    cy: 71.815,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.045,
    cy: 112.64,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.95,
    cy: 114.15,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.54,
    cy: 151.57,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.84,
    cy: 130.4,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.83,
    cy: 153.46,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.05,
    cy: 153.08,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.89,
    cy: 116.42,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.46,
    cy: 104.32,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.15,
    cy: 130.4,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.24,
    cy: 132.67,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.43,
    cy: 147.79,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.2,
    cy: 123.98,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.03,
    cy: 111.12,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.94,
    cy: 104.32,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.71,
    cy: 114.9,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.68,
    cy: 119.44,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.32,
    cy: 133.05,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.79,
    cy: 147.41,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.22,
    cy: 140.99,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.68,
    cy: 143.63,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.16,
    cy: 119.44,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.29,
    cy: 105.46,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.384,
    cy: 103.57,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.155,
    cy: 123.6,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.423,
    cy: 139.47,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.652,
    cy: 156.48,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.65,
    cy: 124.73,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.63,
    cy: 142.5,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.66,
    cy: 109.99,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.97,
    cy: 103.94,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.73,
    cy: 119.06,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.26,
    cy: 131.16,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.27,
    cy: 131.91,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.31,
    cy: 151.95,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.15,
    cy: 145.52,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.55,
    cy: 154.97,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206,
    cy: 137.21,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.93,
    cy: 122.09,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.39,
    cy: 116.42,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.97,
    cy: 135.69,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.38,
    cy: 116.42,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.07,
    cy: 120.95,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.57,
    cy: 111.12,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 140.99,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.62,
    cy: 140.99,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.1,
    cy: 127,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.86,
    cy: 155.73,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.78,
    cy: 148.54,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.45,
    cy: 136.07,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.38,
    cy: 123.6,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.52,
    cy: 106.59,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.789,
    cy: 130.02,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.696,
    cy: 131.54,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.286,
    cy: 168.96,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.58,
    cy: 147.79,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.57,
    cy: 170.85,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.792,
    cy: 170.47,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.64,
    cy: 133.8,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.202,
    cy: 121.71,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.89,
    cy: 147.79,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.979,
    cy: 150.06,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.179,
    cy: 165.18,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.94,
    cy: 141.36,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.777,
    cy: 128.51,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.68,
    cy: 121.71,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.45,
    cy: 132.29,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.423,
    cy: 136.83,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.06,
    cy: 150.43,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.539,
    cy: 164.8,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.97,
    cy: 158.37,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.43,
    cy: 161.02,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.908,
    cy: 136.83,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.036,
    cy: 122.84,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.128,
    cy: 120.95,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.899,
    cy: 140.99,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.167,
    cy: 156.86,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.396,
    cy: 173.87,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.39,
    cy: 142.12,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.375,
    cy: 159.88,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.408,
    cy: 127.38,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.72,
    cy: 121.33,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.47,
    cy: 136.45,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.01,
    cy: 148.54,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.01,
    cy: 149.3,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.05,
    cy: 169.33,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.89,
    cy: 162.91,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.29,
    cy: 172.36,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.74,
    cy: 154.59,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.673,
    cy: 139.47,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.131,
    cy: 133.8,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 153.08,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.12,
    cy: 133.8,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.815,
    cy: 138.34,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.31,
    cy: 128.51,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.458,
    cy: 158.37,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.366,
    cy: 158.37,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.848,
    cy: 144.39,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.604,
    cy: 173.11,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.53,
    cy: 165.93,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.2,
    cy: 153.46,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.12,
    cy: 140.99,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.27,
    cy: 123.98,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.312,
    cy: 166.31,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.22,
    cy: 167.82,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.81,
    cy: 205.24,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.1,
    cy: 184.07,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.1,
    cy: 207.13,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.32,
    cy: 206.75,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.16,
    cy: 170.09,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.73,
    cy: 157.99,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.41,
    cy: 184.07,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.5,
    cy: 186.34,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.7,
    cy: 201.46,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.47,
    cy: 177.65,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.3,
    cy: 164.8,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.21,
    cy: 157.99,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.97,
    cy: 168.58,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.95,
    cy: 173.11,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.58,
    cy: 186.72,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.06,
    cy: 201.08,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.49,
    cy: 194.66,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.95,
    cy: 197.3,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.43,
    cy: 173.11,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.56,
    cy: 159.13,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.652,
    cy: 157.24,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.423,
    cy: 177.27,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.69,
    cy: 193.15,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.92,
    cy: 210.15,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.91,
    cy: 178.4,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.9,
    cy: 196.17,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.93,
    cy: 163.66,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.24,
    cy: 157.62,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206,
    cy: 172.74,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.53,
    cy: 184.83,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.54,
    cy: 185.59,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.58,
    cy: 205.62,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.41,
    cy: 199.19,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.82,
    cy: 208.64,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.26,
    cy: 190.88,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.2,
    cy: 175.76,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.65,
    cy: 170.09,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.24,
    cy: 189.37,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.65,
    cy: 170.09,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.34,
    cy: 174.62,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.83,
    cy: 164.8,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.982,
    cy: 194.66,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.89,
    cy: 194.66,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.37,
    cy: 180.67,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.13,
    cy: 209.4,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.05,
    cy: 202.22,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.72,
    cy: 189.74,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.64,
    cy: 177.27,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.79,
    cy: 160.26,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.301,
    cy: 180.67,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.208,
    cy: 182.18,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.798,
    cy: 219.6,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.092,
    cy: 198.44,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.09,
    cy: 221.49,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.304,
    cy: 221.12,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.15,
    cy: 184.45,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 172.36,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.4,
    cy: 198.44,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.491,
    cy: 200.71,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.69,
    cy: 215.82,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.46,
    cy: 192.01,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.289,
    cy: 179.16,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.2,
    cy: 172.36,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.96,
    cy: 182.94,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.935,
    cy: 187.48,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.571,
    cy: 201.08,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.051,
    cy: 215.45,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.48,
    cy: 209.02,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.94,
    cy: 211.67,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.42,
    cy: 187.48,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.548,
    cy: 173.49,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.64,
    cy: 171.6,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.411,
    cy: 191.63,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.679,
    cy: 207.51,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.908,
    cy: 224.52,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.902,
    cy: 192.77,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.887,
    cy: 210.53,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.92,
    cy: 178.03,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.23,
    cy: 171.98,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.99,
    cy: 187.1,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.52,
    cy: 199.19,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.53,
    cy: 199.95,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.57,
    cy: 219.98,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.4,
    cy: 213.56,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.8,
    cy: 223.01,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.25,
    cy: 205.24,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.185,
    cy: 190.12,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.643,
    cy: 184.45,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.226,
    cy: 203.73,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.64,
    cy: 184.45,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.327,
    cy: 188.99,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.821,
    cy: 179.16,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.97,
    cy: 209.02,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.878,
    cy: 209.02,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.36,
    cy: 195.04,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.116,
    cy: 223.76,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.04,
    cy: 216.58,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.71,
    cy: 204.11,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.63,
    cy: 191.63,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.78,
    cy: 174.62,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.6934,
    cy: 226.79,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.601,
    cy: 228.3,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.19,
    cy: 265.72,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.485,
    cy: 244.55,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.48,
    cy: 267.61,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.696,
    cy: 267.23,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.54,
    cy: 230.57,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.107,
    cy: 218.47,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.79,
    cy: 244.55,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.884,
    cy: 246.82,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.083,
    cy: 261.94,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.848,
    cy: 238.13,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.682,
    cy: 225.27,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.59,
    cy: 218.47,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.35,
    cy: 229.05,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.327,
    cy: 233.59,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.964,
    cy: 247.2,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.443,
    cy: 261.56,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.872,
    cy: 255.13,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.33,
    cy: 257.78,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.812,
    cy: 233.59,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.94,
    cy: 219.6,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.033,
    cy: 217.71,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.8036,
    cy: 237.75,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.0714,
    cy: 253.62,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.301,
    cy: 270.63,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.295,
    cy: 238.88,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.28,
    cy: 256.65,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.312,
    cy: 224.14,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.62,
    cy: 218.09,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.38,
    cy: 233.21,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.91,
    cy: 245.31,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.92,
    cy: 246.06,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.958,
    cy: 266.1,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.79,
    cy: 259.67,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.2,
    cy: 269.12,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.65,
    cy: 251.35,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.577,
    cy: 236.24,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.036,
    cy: 230.57,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.619,
    cy: 249.84,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.03,
    cy: 230.57,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.72,
    cy: 235.1,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.214,
    cy: 225.27,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.363,
    cy: 255.13,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.271,
    cy: 255.13,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.753,
    cy: 241.15,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.509,
    cy: 269.88,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.43,
    cy: 262.69,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.1,
    cy: 250.22,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.02,
    cy: 237.75,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.17,
    cy: 220.74,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.604,
    cy: 211.67,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.51,
    cy: 213.18,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.1,
    cy: 250.6,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.4,
    cy: 229.43,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.39,
    cy: 252.49,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.61,
    cy: 252.11,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.45,
    cy: 215.45,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.02,
    cy: 203.35,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.71,
    cy: 229.43,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.79,
    cy: 231.7,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.99,
    cy: 246.82,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.76,
    cy: 223.01,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.59,
    cy: 210.15,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.5,
    cy: 203.35,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.26,
    cy: 213.93,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.24,
    cy: 218.47,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.88,
    cy: 232.08,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.35,
    cy: 246.44,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.78,
    cy: 240.01,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.24,
    cy: 242.66,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.72,
    cy: 218.47,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.85,
    cy: 204.49,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.94,
    cy: 202.6,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 222.63,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.982,
    cy: 238.5,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.21,
    cy: 255.51,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.21,
    cy: 223.76,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.19,
    cy: 241.53,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.22,
    cy: 209.02,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.53,
    cy: 202.97,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.29,
    cy: 218.09,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.82,
    cy: 230.19,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.83,
    cy: 230.94,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.87,
    cy: 250.98,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.71,
    cy: 244.55,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.11,
    cy: 254,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.56,
    cy: 236.24,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.49,
    cy: 221.12,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.95,
    cy: 215.45,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.53,
    cy: 234.72,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.94,
    cy: 215.45,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.63,
    cy: 219.98,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.12,
    cy: 210.15,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.274,
    cy: 240.01,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.18,
    cy: 240.01,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.66,
    cy: 226.03,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.42,
    cy: 254.76,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.34,
    cy: 247.57,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.01,
    cy: 235.1,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.93,
    cy: 222.63,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.08,
    cy: 205.62,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.336,
    cy: 253.24,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.24,
    cy: 254.76,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.83,
    cy: 292.18,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.13,
    cy: 271.01,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.12,
    cy: 294.07,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.34,
    cy: 293.69,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.18,
    cy: 257.02,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.75,
    cy: 244.93,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.44,
    cy: 271.01,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.53,
    cy: 273.28,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.73,
    cy: 288.4,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.49,
    cy: 264.58,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.32,
    cy: 251.73,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.23,
    cy: 244.93,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206,
    cy: 255.51,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.97,
    cy: 260.05,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.61,
    cy: 273.65,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.09,
    cy: 288.02,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.51,
    cy: 281.59,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.97,
    cy: 284.24,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.46,
    cy: 260.05,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.58,
    cy: 246.06,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.68,
    cy: 244.17,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.446,
    cy: 264.21,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 280.08,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.94,
    cy: 297.09,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.94,
    cy: 265.34,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.92,
    cy: 283.1,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.96,
    cy: 250.6,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.26,
    cy: 244.55,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.02,
    cy: 259.67,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.56,
    cy: 271.76,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.56,
    cy: 272.52,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.6,
    cy: 292.55,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.44,
    cy: 286.13,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.84,
    cy: 295.58,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.29,
    cy: 277.81,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.22,
    cy: 262.69,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.68,
    cy: 257.02,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.26,
    cy: 276.3,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.67,
    cy: 257.02,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.36,
    cy: 261.56,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.86,
    cy: 251.73,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.006,
    cy: 281.59,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.91,
    cy: 281.59,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.4,
    cy: 267.61,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.15,
    cy: 296.33,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.07,
    cy: 289.15,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.74,
    cy: 276.68,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.67,
    cy: 264.21,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 198.82,
    cy: 247.2,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.6458,
    cy: 251.73,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.554,
    cy: 253.24,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.143,
    cy: 290.66,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.438,
    cy: 269.5,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.43,
    cy: 292.55,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.649,
    cy: 292.18,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.494,
    cy: 255.51,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.06,
    cy: 243.42,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.75,
    cy: 269.5,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.836,
    cy: 271.76,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.036,
    cy: 286.88,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.801,
    cy: 263.07,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.634,
    cy: 250.22,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.54,
    cy: 243.42,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.31,
    cy: 254,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.28,
    cy: 258.54,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.917,
    cy: 272.14,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.396,
    cy: 286.51,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.824,
    cy: 280.08,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.28,
    cy: 282.73,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.765,
    cy: 258.54,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.893,
    cy: 244.55,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.985,
    cy: 242.66,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.75594,
    cy: 262.69,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.0238,
    cy: 278.57,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.253,
    cy: 295.58,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.247,
    cy: 263.83,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.232,
    cy: 281.59,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.265,
    cy: 249.09,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.57,
    cy: 243.04,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.33,
    cy: 258.16,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.87,
    cy: 270.25,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.872,
    cy: 271.01,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.911,
    cy: 291.04,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.75,
    cy: 284.62,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.15,
    cy: 294.07,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.6,
    cy: 276.3,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.53,
    cy: 261.18,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.988,
    cy: 255.51,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.571,
    cy: 274.79,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.982,
    cy: 255.51,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.673,
    cy: 260.05,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.167,
    cy: 250.22,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.3155,
    cy: 280.08,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.223,
    cy: 280.08,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.705,
    cy: 266.1,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.461,
    cy: 294.82,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.384,
    cy: 287.64,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.05,
    cy: 275.17,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.98,
    cy: 262.69,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.12,
    cy: 245.68,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.6458,
    cy: 174.62,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.554,
    cy: 176.14,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.143,
    cy: 213.56,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.437,
    cy: 192.39,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.43,
    cy: 215.45,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.649,
    cy: 215.07,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.494,
    cy: 178.4,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.06,
    cy: 166.31,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.75,
    cy: 192.39,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.836,
    cy: 194.66,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.036,
    cy: 209.78,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.801,
    cy: 185.96,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.634,
    cy: 173.11,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.54,
    cy: 166.31,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.31,
    cy: 176.89,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.28,
    cy: 181.43,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.917,
    cy: 195.04,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.396,
    cy: 209.4,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.824,
    cy: 202.97,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.28,
    cy: 205.62,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.765,
    cy: 181.43,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.893,
    cy: 167.44,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.985,
    cy: 165.55,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.75595,
    cy: 185.59,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.0238,
    cy: 201.46,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.253,
    cy: 218.47,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.247,
    cy: 186.72,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.232,
    cy: 204.49,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.265,
    cy: 171.98,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.57,
    cy: 165.93,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.33,
    cy: 181.05,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.87,
    cy: 193.15,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.872,
    cy: 193.9,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.911,
    cy: 213.93,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.75,
    cy: 207.51,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.15,
    cy: 216.96,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.6,
    cy: 199.19,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.53,
    cy: 184.07,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.988,
    cy: 178.4,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.571,
    cy: 197.68,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.982,
    cy: 178.4,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.673,
    cy: 182.94,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.167,
    cy: 173.11,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.3155,
    cy: 202.97,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.223,
    cy: 202.97,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.705,
    cy: 188.99,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.461,
    cy: 217.71,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.384,
    cy: 210.53,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.05,
    cy: 198.06,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.98,
    cy: 185.59,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.12,
    cy: 168.58,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.6458,
    cy: 119.44,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.554,
    cy: 120.95,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.143,
    cy: 158.37,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.437,
    cy: 137.21,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.43,
    cy: 160.26,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.649,
    cy: 159.88,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.494,
    cy: 123.22,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.06,
    cy: 111.12,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.75,
    cy: 137.21,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.836,
    cy: 139.47,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.036,
    cy: 154.59,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.801,
    cy: 130.78,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.634,
    cy: 117.93,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.54,
    cy: 111.12,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.31,
    cy: 121.71,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.28,
    cy: 126.24,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.917,
    cy: 139.85,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.396,
    cy: 154.21,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.824,
    cy: 147.79,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.28,
    cy: 150.43,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.765,
    cy: 126.24,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.893,
    cy: 112.26,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.985,
    cy: 110.37,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.75595,
    cy: 130.4,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.0238,
    cy: 146.28,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.253,
    cy: 163.29,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.247,
    cy: 131.54,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.232,
    cy: 149.3,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.265,
    cy: 116.79,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.57,
    cy: 110.75,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.33,
    cy: 125.87,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.87,
    cy: 137.96,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.872,
    cy: 138.72,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.911,
    cy: 158.75,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.75,
    cy: 152.32,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.15,
    cy: 161.77,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.6,
    cy: 144.01,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.53,
    cy: 128.89,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.988,
    cy: 123.22,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.571,
    cy: 142.5,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.982,
    cy: 123.22,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.673,
    cy: 127.76,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.167,
    cy: 117.93,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.3155,
    cy: 147.79,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.223,
    cy: 147.79,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.705,
    cy: 133.8,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.461,
    cy: 162.53,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.384,
    cy: 155.35,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.05,
    cy: 142.88,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.98,
    cy: 130.4,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.12,
    cy: 113.39,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.1577,
    cy: 10.583,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.065,
    cy: 12.095,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.655,
    cy: 49.515,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.949,
    cy: 28.348,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.94,
    cy: 51.405,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.161,
    cy: 51.027,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.006,
    cy: 14.363,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.571,
    cy: 2.2679,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.26,
    cy: 28.348,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.348,
    cy: 30.616,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.548,
    cy: 45.735,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.312,
    cy: 21.923,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.146,
    cy: 9.0714,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.05,
    cy: 2.2679,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.82,
    cy: 12.851,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.792,
    cy: 17.387,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.429,
    cy: 30.994,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.908,
    cy: 45.357,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.336,
    cy: 38.932,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.79,
    cy: 41.577,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.277,
    cy: 17.387,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.405,
    cy: 3.4018,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.497,
    cy: 1.5119,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.2679,
    cy: 21.545,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5357,
    cy: 37.42,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.765,
    cy: 54.429,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.759,
    cy: 22.679,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.744,
    cy: 40.443,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.777,
    cy: 7.9375,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.09,
    cy: 1.8899,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.84,
    cy: 17.009,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.38,
    cy: 29.104,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.384,
    cy: 29.86,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.423,
    cy: 49.893,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.26,
    cy: 43.467,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.66,
    cy: 52.917,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.11,
    cy: 35.152,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.042,
    cy: 20.033,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.5,
    cy: 14.363,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.083,
    cy: 33.64,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.494,
    cy: 14.363,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.185,
    cy: 18.899,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.679,
    cy: 9.0714,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.8274,
    cy: 38.932,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.735,
    cy: 38.932,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.217,
    cy: 24.946,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.973,
    cy: 53.673,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.896,
    cy: 46.491,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.57,
    cy: 34.018,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.49,
    cy: 21.545,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.64,
    cy: 4.5357,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.604,
    cy: 12.095,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.51,
    cy: 13.607,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.1,
    cy: 51.027,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.4,
    cy: 29.86,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.39,
    cy: 52.917,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.61,
    cy: 52.539,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.45,
    cy: 15.875,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.02,
    cy: 3.7798,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.71,
    cy: 29.86,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.79,
    cy: 32.128,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.99,
    cy: 47.247,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.76,
    cy: 23.435,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.59,
    cy: 10.583,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.5,
    cy: 3.7798,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.26,
    cy: 14.363,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.24,
    cy: 18.899,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.88,
    cy: 32.506,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.35,
    cy: 46.869,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.78,
    cy: 40.443,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.24,
    cy: 43.089,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.72,
    cy: 18.899,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.85,
    cy: 4.9137,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.94,
    cy: 3.0238,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 23.057,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.982,
    cy: 38.932,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.21,
    cy: 55.94,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.21,
    cy: 24.19,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.19,
    cy: 41.955,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.22,
    cy: 9.4494,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.53,
    cy: 3.4018,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.29,
    cy: 18.521,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.82,
    cy: 30.616,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.83,
    cy: 31.372,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.87,
    cy: 51.405,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.71,
    cy: 44.979,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.11,
    cy: 54.429,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.56,
    cy: 36.664,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.49,
    cy: 21.545,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.95,
    cy: 15.875,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.53,
    cy: 35.152,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.94,
    cy: 15.875,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.63,
    cy: 20.411,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.12,
    cy: 10.583,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.274,
    cy: 40.443,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.18,
    cy: 40.443,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.66,
    cy: 26.458,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.42,
    cy: 55.185,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.34,
    cy: 48.003,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.01,
    cy: 35.53,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.93,
    cy: 23.057,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.08,
    cy: 6.0476,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.604,
    cy: 40.065,
    rx: 8.6935,
    ry: 6.4256,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.51,
    cy: 41.577,
    rx: 17.387,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.1,
    cy: 78.997,
    rx: 9.8274,
    ry: 6.8036,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.4,
    cy: 57.83,
    rx: 7.9375,
    ry: 6.0476,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.39,
    cy: 80.887,
    rx: 5.6696,
    ry: 7.9375,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.61,
    cy: 80.509,
    rx: 9.8274,
    ry: 7.5595,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.45,
    cy: 43.845,
    rx: 9.0714,
    ry: 4.1577,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.02,
    cy: 31.75,
    rx: 9.0714,
    ry: 4.9137,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.71,
    cy: 57.83,
    rx: 15.497,
    ry: 9.0714,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.79,
    cy: 60.098,
    rx: 15.497,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.99,
    cy: 75.217,
    rx: 10.583,
    ry: 5.2917,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.76,
    cy: 51.405,
    rx: 7.9375,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.59,
    cy: 38.554,
    r: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.5,
    cy: 31.75,
    rx: 14.363,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.26,
    cy: 42.333,
    rx: 11.717,
    ry: 4.9137,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.24,
    cy: 46.869,
    rx: 11.339,
    ry: 5.6696,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.88,
    cy: 60.476,
    rx: 10.583,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.35,
    cy: 74.839,
    rx: 13.229,
    ry: 8.6935,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.78,
    cy: 68.414,
    rx: 12.473,
    ry: 8.3155,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.24,
    cy: 71.06,
    rx: 7.1815,
    ry: 6.4256,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.72,
    cy: 46.869,
    rx: 11.717,
    ry: 7.9375,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.85,
    cy: 32.884,
    rx: 22.679,
    ry: 6.0476,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.94,
    cy: 30.994,
    rx: 7.1815,
    ry: 3.4018,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 51.027,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.982,
    cy: 66.902,
    rx: 7.5595,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.21,
    cy: 83.911,
    rx: 16.253,
    ry: 4.1577,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.21,
    cy: 52.161,
    rx: 13.985,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.19,
    cy: 69.926,
    rx: 14.363,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.22,
    cy: 37.42,
    rx: 7.9375,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.53,
    cy: 31.372,
    rx: 7.1815,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.29,
    cy: 46.491,
    rx: 15.497,
    ry: 3.7798,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.82,
    cy: 58.586,
    rx: 5.6696,
    ry: 5.2917,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.83,
    cy: 59.342,
    rx: 10.961,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.87,
    cy: 79.375,
    rx: 11.339,
    ry: 5.6696,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.71,
    cy: 72.949,
    rx: 9.4494,
    ry: 6.0476,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.11,
    cy: 82.399,
    rx: 6.0476,
    ry: 2.6458,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.56,
    cy: 64.634,
    rx: 2.6458,
    ry: 4.5357,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.49,
    cy: 49.515,
    rx: 11.339,
    ry: 6.8036,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.95,
    cy: 43.845,
    rx: 13.607,
    ry: 8.6935,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.53,
    cy: 63.122,
    rx: 16.631,
    ry: 5.2917,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.94,
    cy: 43.845,
    rx: 18.899,
    ry: 10.205,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.63,
    cy: 48.381,
    rx: 4.5357,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.12,
    cy: 38.554,
    rx: 12.851,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.274,
    cy: 68.414,
    rx: 9.0714,
    ry: 7.5595,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.18,
    cy: 68.414,
    rx: 23.812,
    ry: 6.8036,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.66,
    cy: 54.429,
    rx: 10.961,
    ry: 5.6696,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.42,
    cy: 83.155,
    rx: 12.473,
    ry: 4.1577,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.34,
    cy: 75.973,
    rx: 4.9137,
    ry: 3.7798,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.01,
    cy: 63.5,
    rx: 2.2679,
    ry: 2.6458,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.93,
    cy: 51.027,
    r: 9.8274,
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.08,
    cy: 34.018,
    rx: 8.3155,
    ry: 7.1815,
    fill: "#4d4d4d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPebbles);
export default __webpack_public_path__ + "static/media/pebbles.c68e72230febc2c9384cccbc80cf6cb7.svg";
export { ForwardRef as ReactComponent };